import { FlexContainer, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import useTranslation from 'Hooks/useTranslation';
import { openLinkInNewTab } from 'Utils/links';
import * as Styled from './styles';
import { HeaderInfoProps } from './types';

const sizes = {
  h1: { type: 'headline', size: 'S_L_L' },
  h2: { type: 'headline', size: 'XS_L_L' },
  h3: { type: 'headline', size: 'XS_L_L' },
  h4: { type: 'paragraphs', size: 'L_XL_M' },
  h5: { type: 'paragraphs', size: 'M_XL_M' },
};

const HeaderInfo = ({
  align = 'flex-start',
  mb = 'dimension_01',
  justify = 'space-between',
  className = '',
  children,
  info,
  tag = 'h1',
  title = '',
  ...rest
}: HeaderInfoProps): JSX.Element => {
  const { type, size } = sizes[tag];
  const { t } = useTranslation(locizeNS.COMMON);
  const handleOnClick = (url: string): void => {
    openLinkInNewTab(url);
  };

  return (
    <FlexContainer mb={mb} justify={justify} align={align} className={className}>
      <Text tag={tag} type={type} size={size} color="dark" {...rest}>
        {children}
        {title}
        {info && (
          <Styled.HelpButton
            mode="success_light"
            onClick={() => handleOnClick(info)}
            label={t('ContextualHelp')}
          />
        )}
      </Text>
    </FlexContainer>
  );
};

export default HeaderInfo;
